import { render, staticRenderFns } from "./product-detail-cancel.vue?vue&type=template&id=6ee21960&functional=true&"
import script from "./product-detail-cancel.vue?vue&type=script&lang=js&"
export * from "./product-detail-cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports